import { Region } from 'hooks/useRegion'

export const GetRegion = (envRegionKey = 'REACT_APP_REGION') => {
  return process.env[envRegionKey] as Region
}
